import axios from "axios";

const baseDomain = process.env.VUE_APP_API_BASE_URL;

const baseURL = `${baseDomain}/api`;

const token = localStorage.getItem("token");

const AxiosInstance = axios.create({
  baseURL,
  headers: {
    common: {
      Token: token ? token : null
    }
  }
});

export const getDefaultCRUDMethods = ({ resource }) => ({
  get({
    page = 1,
    pageSize = 30,
    sortField = "nom",
    sortType = "asc",
    searchQuery = "",
    cancelToken = null
  }) {
    return AxiosInstance.post(
      `${resource}/Search`,
      {
        pageNumber: page,
        pageSize,
        sortField,
        sortType
      },
      {
        cancelToken,
        params: {
          criteria: searchQuery !== null ? searchQuery : ""
        }
      }
    ).then(res => {
      if (res.data && res.data.content && res.data.content.list) {
        res.data.content.list = res.data.content.list.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        );
      }
      return res;
    });
  },
  findOneById(id) {
    return AxiosInstance.get(`${resource}/${id}`);
  },
  put({ entity, id = "" }) {
    if (id != null) {
      return AxiosInstance.put(`${resource}/${id}`, entity);
    } else {
      return AxiosInstance.post(`${resource}`, entity);
    }
  },
  deleteOneById(id) {
    return AxiosInstance.delete(`${resource}/${id}`);
  }
});

export default AxiosInstance;
